import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError("로그인 실패: " + err.message);
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    try {
      await signInWithPopup(auth, provider);
      navigate('/');
    } catch (err) {
      console.error("Google Login Error:", err);
      setError("구글 로그인 실패: " + err.message);
    }
  };

  return (
    <>
      <Header />
      <div style={{ maxWidth: "400px", margin: "60px auto", padding: "20px" }}>
        <h2 style={{ textAlign: "center", marginBottom: "24px" }}>로그인</h2>
        
        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <input 
            type="email" 
            placeholder="이메일" 
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{ padding: "12px", borderRadius: "4px", border: "1px solid #ddd" }}
          />
          <input 
            type="password" 
            placeholder="비밀번호" 
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={{ padding: "12px", borderRadius: "4px", border: "1px solid #ddd" }}
          />
          
          {error && <p style={{ color: "red", fontSize: "0.9rem" }}>{error}</p>}
          
          <button type="submit" className="btn-primary" style={{ padding: "12px", fontSize: "1rem", marginTop: "8px" }}>
            로그인
          </button>
        </form>

        <div style={{ display: "flex", alignItems: "center", margin: "24px 0" }}>
          <div style={{ flex: 1, height: "1px", background: "#eee" }}></div>
          <span style={{ padding: "0 12px", color: "#868e96", fontSize: "0.9rem" }}>또는</span>
          <div style={{ flex: 1, height: "1px", background: "#eee" }}></div>
        </div>

        <button 
          onClick={handleGoogleLogin}
          style={{ 
            width: "100%", 
            padding: "12px", 
            background: "#fff", 
            border: "1px solid #ddd", 
            borderRadius: "4px", 
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            fontSize: "1rem"
          }}
        >
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{ width: "18px" }} />
          Google로 계속하기
        </button>

        <p style={{ textAlign: "center", marginTop: "24px", color: "#495057" }}>
          계정이 없으신가요? <Link to="/register" style={{ color: "#339af0", textDecoration: "none", fontWeight: "bold" }}>회원가입</Link>
        </p>
      </div>
    </>
  );
}

export default Login;
